import BinarySocket from '_common/base/socket_base';

const WS = BinarySocket;

export default WS;
